const webBorrowerPortalService = {
  fileName: "remoteEntry.js",
  name: "OP_WEB_BORROWER_PORTAL_V2_SERVICE",
  port: 3001,
  get url() {
    return window.location.protocol === "http:"
      ? `http://${window.location.hostname}:3001/webborrowerportalv2`
      : `${window.location.origin}/webborrowerportalv2`;
  },
  urlGlobalVariable: "OP_WEB_BORROWER_PORTAL_V2_SERVICEUrl",
  get federationConfig() {
    return `${this.name}@[window.${this.urlGlobalVariable}]/${this.fileName}`;
  }
};

module.exports = {
  webBorrowerPortalService
};
